import { translateWord } from "../../Util/util"
import { useRouter } from "../../../hooks/router"

export default ({
    setShowSidebarSettings,
    showSidebarSettings,
    click_settings_item,
    navBarSettings,
    notReadMessagesCount
}) => {

    const router = useRouter()

    return (

        <div className={"parent_sidebar_settings " + (showSidebarSettings ? 'show' : '')} >
            <div className="settings_arrow_mobile" onClick={() => setShowSidebarSettings(!showSidebarSettings)}></div>
            <div className="items_settings_sidebar">

                {

                    navBarSettings.map((e, i) => {
                        return (
                            <div className="parent_item_sidebar" key={e.id} >
                                {
                                    notReadMessagesCount && e.query == 'messages' ?
                                        <div className="unread_message_count_sidebar">

                                        </div>
                                        : null
                                }
                                <div className={"item_settings_sidebar " + (e.active ? 'selected' : '')} onClick={() => {

                                    setShowSidebarSettings(!showSidebarSettings)

                                    click_settings_item(e)

                                }}>

                                    <img src={e.icon} alt="" />
                                    <p>{translateWord(e.title)}</p>
                                </div>
                            </div>

                        )
                    })

                }

            </div>
        </div>

    )

}